var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeirdCircleThing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 56,
    viewBox: "0 0 214 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.311 22.326C66.418 4.096 139.607 1.485 176.487 3.159c33.193 1.506 45.568 15.675 24.576 26.51C157.161 52.326 80.698 57.254 35.816 48.73c-24.824-4.715-53.87-19.289-12.034-36.133",
    stroke: "#7DD7AA",
    strokeWidth: 5
  })));
}

export default __webpack_public_path__ + "./fonts/weird-circle-thing.73ff2195c83d3245727c94e0b0d18b20.svg";
export { SvgWeirdCircleThing as ReactComponent };